<div class="pres-prescription-item">
  <a routerLink="/prescription/{{id}}/detail"
     [attr.aria-label]="'SI_DETAIL_PRESCRIPTION' | translate">
    <div class="pres-prescription-item_container pointer pasi-hover_scale" [class.pres-prescription-item_container_secondary]="isPast">
      <div class="d-flex align-items-center">
        <div class="text-wrap flex-grow-1">
          <div class="pres-prescription-item_container_title">{{title}}</div>
        </div>
        <div class="ml-auto mr-1">
          <button pTooltip="{{'SI_DOWNLOAD_PATIENT_INFORMATION_SHEET' | translate}}"
                  tooltipPosition="top"
                  class="si-button_icon"
                  (click)="onClickDownloadPatientInformationSheet()">
            <i class="icosun-filepdf pasi-action-button_icon"></i>
          </button>
        </div>
      </div>
      <div class="pasi-line-lightgrey my-1"></div>
      <div class="d-flex w-100">
        <div class="pres-prescription-item_container_box">
          <div class="pres-prescription-item_container_state text-right" [class.pres-prescription-item_container_danger]="!isCurrent">
            {{stateText | translate}}
          </div>
          <div class="pres-prescription-item_container_title text-right">
            {{initDate | amDateFormat: 'DD MMM' | uppercase}}
          </div>
          <div class="pres-prescription-item_container_year text-right">
            {{initDate | amDateFormat: 'YYYY'}}
          </div>
        </div>
        <div class="pasi-v-line-small-lightgrey"></div>
        <div class="d-flex flex-column justify-content-center text-truncate">
          <div class="d-flex align-items-center pres-prescription-item_container_dosage">
            <i class="icosun-pill mr-1"></i>
            <span class="text-truncate">{{posology}}</span>
          </div>
          <div *ngIf="instructions" class="d-flex align-items-center pres-prescription-item_container_darkgrey">
            <i class="icosun-message-reply-text mr-1"></i>
            <span class="text-truncate">{{instructions}}</span>
          </div>
          <div class="d-flex align-items-center pres-prescription-item_container_darkgrey">
            <ng-container *ngIf="endDate; else doesNotEnd">
              <i class="icosun-calendar mr-1"></i>
              <span [class.bold]="isCurrent">{{'SI_UNTIL' | translate}}&nbsp;{{endDate | amDateFormat: 'L'}}</span>
            </ng-container>
            <ng-template #doesNotEnd>
              <i class="icosun-calendar_change mr-1"></i>
              <span class="bold">{{'SI_DOES_NOT_END' | translate}}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
